var StatisticsSortingTypes;
(function (StatisticsSortingTypes) {
    StatisticsSortingTypes[StatisticsSortingTypes["Default"] = 0] = "Default";
    StatisticsSortingTypes[StatisticsSortingTypes["Ascending"] = 1] = "Ascending";
    StatisticsSortingTypes[StatisticsSortingTypes["Descending"] = 2] = "Descending";
})(StatisticsSortingTypes || (StatisticsSortingTypes = {}));

export { StatisticsSortingTypes };
